'use client'

import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog'
import { useModalStore } from '@/stores/modal-store'
import { ArrowLeftRight, CreditCard, Shuffle } from 'lucide-react'
import { DepositOption } from './deposit-option'

export function DepositPrimaryModal() {
	const { activeModal, closeModal, openModal } = useModalStore()
	const isOpen = activeModal === 'deposit-primary'

	const handleManualTransfer = () => {
		closeModal()
		openModal('manual-transfer')
	}

	const handleMoonPayDeposit = () => {
		closeModal()
		openModal('moonpay-deposit')
	}

	const handleLiFiDeposit = () => {
		closeModal()
		openModal('lifi-deposit')
	}

	return (
		<Dialog open={isOpen} onOpenChange={open => !open && closeModal()}>
			<DialogContent
				closeButtonClasses="size-[24px]  text-white"
				closeButtonContainerClasses="top-[20px] right-[26px]  cursor-pointer"
				className="gap-[24px] rounded-3xl border border-white/10 bg-brand-dark-light p-[24px] sm:max-w-[512px]"
			>
				<DialogHeader className="flex flex-col gap-[8px]">
					<DialogTitle className="text-center font-semibold text-[18px] text-white leading-[100%]">
						Deposit Funds
					</DialogTitle>
					<DialogDescription className="text-center text-[16px] text-brand-gray-secondary leading-[100%]">
						Choose a method to add funds securely.
					</DialogDescription>
				</DialogHeader>

				<div className="flex flex-col gap-[16px]">
					<DepositOption
						icon={<Shuffle className="h-8 w-8 text-brand-muted" />}
						title="Bridge with LI.FI (Recommended)"
						description="Swap from any chain to the market you want."
						onClick={handleLiFiDeposit}
						highlighted
					/>

					<DepositOption
						icon={<CreditCard className="h-8 w-8 text-brand-muted" />}
						title="Deposit with"
						logoSrc="/logos/moonpay.logo-full-white.svg"
						description="Use crypto, Apple Pay, or Google Pay."
						onClick={handleMoonPayDeposit}
					/>

					<DepositOption
						icon={<ArrowLeftRight className="h-8 w-8 text-brand-muted" />}
						title="Deposit Manually"
						description="Copy an address to send funds directly."
						onClick={handleManualTransfer}
					/>
				</div>
			</DialogContent>
		</Dialog>
	)
}
